import React from 'react'
import './VisualBox.scss'

const VisualBox = props => {
  return (
    <div className="visual-box">
      <div className="title-label">{props.title}</div>
      <div className="detail">
        {props.children}
        {props.label1 && <div className="label1">{props.label1}</div>}
        {props.label2 && <div className="label2">{props.label2}</div>}
        {props.label3 && <div className="label3">{props.label3}</div>}
      </div>
    </div>
  )
}

export default VisualBox



// WEBPACK FOOTER //
// ./src/components/viz/VisualBox.js